@use '@/sass/variables';

$hot_number_column_icon_size: 16px;

.RowHeaderWithControls {
  .Container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    cursor: pointer;

    .Number {
      transition: opacity 0.2s ease-in-out;
    }

    .Add {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      svg {
        width: $hot_number_column_icon_size;
        height: $hot_number_column_icon_size;
        fill: variables.$blue;
        display: block;
      }
    }

    .Remove {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: opacity 0.2s ease-in-out;

      svg {
        width: $hot_number_column_icon_size;
        height: $hot_number_column_icon_size;
        fill: variables.$red;
        display: block;
      }
    }
  }

  &:hover {
    .Container .Number {
      opacity: 0;
    }

    .Container .Remove {
      opacity: 1;
    }
  }
}
